export function CitationSVG() {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M17.442.6046C18.4605 3.4363 15.537 13.8971.528 15.8217M20.331 13.7186C20.331 13.7186 19.3905 18.7819 12.222 20.45"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
    </svg>
  )
}
